import { useEffect, useRef, useState } from "react";

/**
 * UUID целиком в колонку не влезает, поэтому показываем начало.
 * Чтобы сокращение не было тупиком — клик копирует полный id,
 * а наведение показывает его в подсказке.
 */
export function AdminCopyId({ id, chars = 8 }: { id: string; chars?: number }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(0);

  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    []
  );

  async function copy(ev: React.MouseEvent) {
    // Строка таблицы может быть кликабельной — копирование её не открывает.
    ev.stopPropagation();
    ev.preventDefault();
    let ok = false;
    try {
      await navigator.clipboard.writeText(id);
      ok = true;
    } catch {
      // Нет доступа к буферу (не https / отказ) — выделяем, чтобы скопировали руками.
      const sel = window.getSelection();
      if (sel) {
        const range = document.createRange();
        range.selectNodeContents(ev.currentTarget);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
    if (!ok) return;
    setCopied(true);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopied(false), 1200);
  }

  return (
    <button
      type="button"
      className="wb-admin-copy-id"
      onClick={(ev) => void copy(ev)}
      title={`${id}\nНажмите, чтобы скопировать`}
      aria-label={`Скопировать ID ${id}`}
    >
      <span className="wb-admin-copy-id__text">{id.slice(0, chars)}</span>
      <span className="wb-admin-copy-id__hint" aria-hidden="true">
        {copied ? "скопировано" : "копировать"}
      </span>
    </button>
  );
}
